import { put, takeEvery } from 'redux-saga/effects'
import { config } from '../../config/global'
import { setData } from '../data-reducer/actions'
import { makeRequest2 } from '../requests'
import { triggerRequestSuccess, TRIGGER_REQUEST } from './actions'
import { normalizers } from './normalizers'

export const executeRequest = (method, url) =>
  makeRequest2(method, url, {
    baseUrl: config.dodoBaseApiURL,
  })

export function* triggerRequest(action) {
  try {
    const [status, response] = yield executeRequest(action.method, action.url)
    const normalizedData = normalizers[action.normalizer](status, response)
    yield put(setData(normalizedData))
    yield put(triggerRequestSuccess(action.id))
  } catch (error) {
    console.error(error)
  }
}

export function* rootSaga() {
  yield takeEvery(TRIGGER_REQUEST, triggerRequest)
}
